import axios from 'axios';
import routes from '../env-routes';

export async function getTranslations(tenantUuid = '', languageCode) {
  try {
    const url = `${
      routes.tc
    }/translations/3fafad62c7c8ba0d5d6bc4e1405d6a53/locales/${languageCode}${tenantUuid ? `/tenants/${tenantUuid}` : ''}?includeLocaleFallback=true`;

    const response = await axios({
      method: 'GET',
      url,
    });

    return response.data;
  } catch (err) {
    console.log('An error occurred while fetching translations', err);
    return null;
  }
}
